import { keepPreviousData, queryOptions, useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { QUERY_KEYS } from '~shared/api/query-keys';

import type { OutgoingPushLogsResponse } from '../model/types';

export interface GetPushLogsParams {
  page?: number;
  limit?: number;
  scenario?: string;
  status?: string;
  startDate?: string;
  endDate?: string;
}

export const getPushLogsAPI = async (params?: GetPushLogsParams) => {
  const response = await baseAPI.get<OutgoingPushLogsResponse>(
    'mobile-inventor-push/logs',
    { params },
  );
  return response.data;
};

export const getPushLogsOptions = (params?: GetPushLogsParams) =>
  queryOptions({
    queryKey: QUERY_KEYS.MOBILE_INVENTOR_PUSH_LOGS(params),
    queryFn: () => getPushLogsAPI(params),
    placeholderData: keepPreviousData,
  });

export const useGetPushLogs = (params?: GetPushLogsParams) =>
  useQuery(getPushLogsOptions(params));
